import { useNavigate } from "react-router-dom";

function urgencyBadge(daysLeft) {
  if (daysLeft < 0)  return { label: "Overdue",         cls: "urgent" };
  if (daysLeft === 0) return { label: "Due today",       cls: "urgent" };
  if (daysLeft <= 3) return { label: `${daysLeft}d left`, cls: "urgent" };
  if (daysLeft <= 7) return { label: `${daysLeft}d left`, cls: "soon"   };
  return               { label: `${daysLeft}d left`, cls: "ok"     };
}

const SkeletonRow = () => (
  <div className="refill-item">
    <div style={{ width: 36, height: 36, borderRadius: 10, background: "#f0f4fa" }} />
    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
      <div style={{ height: 13, width: "60%", borderRadius: 4, background: "#f0f4fa" }} />
      <div style={{ height: 11, width: "40%", borderRadius: 4, background: "#f0f4fa" }} />
    </div>
    <div style={{ width: 52, height: 22, borderRadius: 20, background: "#f0f4fa" }} />
  </div>
);

export default function RefillReminderCard({ loading, items = [] }) {
  const navigate = useNavigate();

  return (
    <div className="ph-card">
      <div className="ph-card-header">
        <div className="ph-card-title">
          <i className="pi pi-clock" />
          Upcoming Refills
        </div>
        <button
          style={{
            background: "none", border: "none", cursor: "pointer",
            fontSize: 12, color: "var(--brand-primary)", fontWeight: 500,
            padding: "4px 8px", borderRadius: 6,
          }}
          onClick={() => navigate("/refills")}
        >
          View all →
        </button>
      </div>

      {loading ? (
        <>
          <SkeletonRow /><SkeletonRow /><SkeletonRow />
        </>
      ) : items.length === 0 ? (
        <div style={{
          padding: "28px 20px", textAlign: "center",
          color: "var(--text-muted)", fontSize: 13,
        }}>
          <i className="pi pi-check-circle" style={{ fontSize: 24, display: "block", marginBottom: 8, color: "var(--status-success)" }} />
          No refills due in the next 30 days
        </div>
      ) : (
        items.map((rx) => {
          const badge = urgencyBadge(rx.daysLeft);
          return (
            <div key={rx.id} className="refill-item">
              <div className="refill-icon">
                <i className="pi pi-tablet" />
              </div>
              <div className="refill-info">
                <div className="refill-name" title={rx.medicine}>
                  {rx.medicine.length > 32
                    ? rx.medicine.slice(0, 32) + "…"
                    : rx.medicine}
                </div>
                <div className="refill-meta">
                  Dr. {rx.doctor} · {rx.itemCount} item{rx.itemCount !== 1 ? "s" : ""}
                </div>
              </div>
              <span className={`refill-badge ${badge.cls}`}>{badge.label}</span>
            </div>
          );
        })
      )}
    </div>
  );
}
